import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.75 11.501a.75.75 0 0 1-.75-.75v-4.25H.75a.75.75 0 0 1 0-1.5H5V.75a.75.75 0 0 1 1.5 0V5h4.251a.75.75 0 0 1 0 1.5h-4.25v4.251a.75.75 0 0 1-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }